// B2C responsive breakpoint — the single source of truth for "phone size".
//
// Phone = viewport width ≤ 767px (below 768). It is purely a width check (no
// OS / device / touch sniffing), so a narrowed desktop window gets the phone
// UI too. Same split as antd's `md` breakpoint and the back office.
//
// LESS: use `@media screen and (max-width: 767px)` (MOBILE_MAX_WIDTH).

/** First width that is no longer a phone (tablet / desktop layouts). */
export const MOBILE_BREAKPOINT = 768;

/** Widest phone width — the value for `max-width` media queries. */
export const MOBILE_MAX_WIDTH = MOBILE_BREAKPOINT - 1;

/** `window.matchMedia` query matching phone-size viewports. */
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;

/** True when a viewport width counts as phone size. */
export const isMobileViewportWidth = (width: number): boolean =>
  width < MOBILE_BREAKPOINT;

// Compact navigation — phones AND tablets / small laptops (< 1200px).
//
// Only for the site chrome: the header (app bar · side menu drawer · cart
// sheet) and the agent banner (strip + details sheet), which do not fit the
// desktop layout below 1200px. Everything else that is phone-only (search
// sheets, result cards, filters …) keeps using isMobileViewportWidth.
//
// LESS: use `@media screen and (max-width: 1199px)` (COMPACT_NAV_MAX_WIDTH).

/** First width that gets the full desktop header / agent banner. */
export const COMPACT_NAV_BREAKPOINT = 1200;

/** Widest compact-navigation width — the value for `max-width` queries. */
export const COMPACT_NAV_MAX_WIDTH = COMPACT_NAV_BREAKPOINT - 1;

/** True when a viewport width gets the compact header / agent strip. */
export const isCompactNavWidth = (width: number): boolean =>
  width < COMPACT_NAV_BREAKPOINT;
